import { AnchorHTMLAttributes, ButtonHTMLAttributes, MouseEventHandler } from 'react';
import { LinkVariant } from '../../enums';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type LinkProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'onClick'> & {
    /**
     * @default LinkVariant.Primary
     * @deprecated 19/11/2024
     */
    variant?: LinkVariant;
    /**
     * **Deprecated:** Use `href`
     * @deprecated 27/05/2021
     */
    link?: string;
    onClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  };

export const E1Link = ({
  children,
  variant = LinkVariant.Primary,
  href,
  link,
  className,
  ...props
}: LinkProps) => {
  const classNames = joinClassNames(styles.link, styles[variant], className);

  return href || link ? (
    <a className={classNames} href={href || link} {...props}>
      {children}
    </a>
  ) : (
    <button role="link" className={classNames} {...props}>
      {children}
    </button>
  );
};
